import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
// import PageUi from 'kts-platform-frame/display/components/PageUi';
import PageUi from 'src/display/components/PageUi';
import Edit from './UI.Edit';
import View from './UI.View';
import {
    Table,
    Modal,
    Icon,
    Popconfirm
} from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        ModulesAction.getUserQuery({
            pageSize: 20,
            pageNum: 1
        });
        ModulesAction.getJobList();
    }

    render() {
        enum userTypeEnum {
            COMMON_USER = '普通用户',
            COMPANY_ADMIN = '公司管理员'
        }
        const columns = [
            {
                title: '用户姓名',
                dataIndex: 'nickName',
                width: 100,
            }, {
                title: '账号',
                dataIndex: 'isContactor',
                width: 200,
                render: (text, record) => {
                    return <div>
                        <div>{Array.isArray(record.authors) ? record.authors[0] : ''}</div>
                    </div>;
                }
            }, {
                title: '联系手机号',
                dataIndex: 'phone',
                width: 130,
            }, {
                title: '联系邮箱',
                dataIndex: 'email',
                width: 180,
            },
            {
                title: '所属部门',
                dataIndex: 'departmentName',
                width: 200,
            }, {
                title: '联系人',
                dataIndex: 'isContactor',
                width: 90,
                render: (text, record) => {
                    if (text) {
                        return "是";
                    } else {
                        return "否";
                    }
                }
            },
            {
                title: '用户角色',
                dataIndex: 'userType',
                width: 100,
                render: (text, record) => userTypeEnum[text]
            },
            {
                title: '用户类型',
                dataIndex: 'isInnerUser',
                width: 100,
                render: (text, record) => {
                    if (text === '1') {
                        return '内部员工';
                    } else {
                        return '外部员工';
                    }
                }
            },
            {
                title: '用户状态',
                dataIndex: 'userStatus',
                width: 120,
                render: (text, record) => {
                    if (record.isActivated) {
                        return <span className={css['table-invite']}><span className={`${css['table-invite-enable']} ${css['table-invite-tip']}`}></span>已启用</span>;
                    } else if (!record.isActivated && record.acceptStatus === 'ACCEPT_ING') {
                        return <span className={css['table-invite']}><span className={`${css['table-invite-invite']} ${css['table-invite-tip']}`}></span>已邀请</span>;
                    } else {
                        return <span className={css['table-invite']}><span className={`${css['table-invite-disabled']} ${css['table-invite-tip']}`}></span>已禁用</span>;
                    }
                }
            },
            {
                title: '操作',
                dataIndex: 'operation',
                fixed: 'right' as any,
                align: 'center' as any,
                center: true,
                width: 160,
                render: (text, record) => {
                    return (
                        <div className={css["table-row-hander"]}>
                            <a
                                onClick={() => {
                                    this.reviewDetali(record);
                                }}
                            >查看
                            </a>
                            <this.userHander record={record} />
                            {
                                !record.isActivated && record.acceptStatus === 'ACCEPT_ING' &&
                                <Popconfirm
                                    title="确定取消该用户?"
                                    okText="是"
                                    cancelText="否"
                                    onConfirm={() => {
                                        ModulesAction.userInviteCancel(record);
                                    }}
                                >
                                    <a>取消</a>
                                </Popconfirm>
                            }
                        </div>
                    );
                }
            }
        ];
        const { userPageMeta } = this.modulesState;
        const data = this.modulesState.userList ? this.modulesState.userList : [];
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                let users = [];
                selectedRows.forEach(ele => {
                    users.push(ele.userId);
                });
                ModulesAction.updateSelectedUsers(users);
            }
        };
        return (
            // <div style={{ height: ('calc(100Vh - 160px)'), overflow: 'auto', minWidth: '1000px' }}>
            //     <InfiniteScroll
            //         initialLoad={false}
            //         pageStart={0}
            //         loadMore={this.handleInfiniteOnLoad}
            //         hasMore={this.modulesState.userPageMeta && this.modulesState.userListPageMeta.pageSize < this.modulesState.userPageMeta.total}
            //         useWindow={false}
            //     >
            //         <Table
            //             className={`${css['table']} kts-app-ant-table`}
            //             columns={columns}
            //             dataSource={data}
            //             pagination={false}
            //             rowSelection={rowSelection}
            //         />
            //     </InfiniteScroll>
            //     <Modal
            //         title="禁用用户"
            //         visible={this.modulesState.disabledModal}
            //         onOk={this.disabledUserSure}
            //         onCancel={this.disabledModalCancel}
            //         className='kts-app-ant-modal'
            //     >
            //         <p style={{ display: 'flex', alignItems: 'center' }}><Icon type="zhuyi" style={{ color: '#ffb301', fontSize: '24px', marginRight: '12px' }} />你确认要禁用用户{this.modulesState.disabledName}吗？</p>
            //     </Modal>
            // </div>
            <div className={css.dataList}>
                <div className={css.table}>
                    <Table
                        className={css.tableBox}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        rowSelection={rowSelection}
                        rowClassName={(record, index) => {
                            let sty: string = '';
                            if ((index + 1) % 2 === 0) {
                                sty = 'rowEventNum';
                            } else {
                                sty = 'rowOddNum';
                            }
                            return sty;
                        }}
                        size="small"
                        rowKey="userId"
                        scroll={{ x: true, y: data.length > 0 && 'calc(100vh - 325px)' }}
                        bordered={true}
                    />
                    {/* {
                        (userPageMeta.total && userPageMeta.total > 0) ?
                            <div className={css.pageUi} style={{zIndex:2}}>
                                <PageUi
                                    pageSize={userPageMeta.pageSize}
                                    data={{ ...userPageMeta }}
                                    onChange={ModulesAction.mapListToPage}
                                    onShowSizeChange={ModulesAction.mapListToPage}
                                />
                            </div> :
                            ''
                    } */}
                    {
                        (userPageMeta.total && userPageMeta.total > 0) ?
                            <div className={css.pageUi} >
                                <PageUi
                                    pageSize={userPageMeta.pageSize}
                                    data={{
                                        ...userPageMeta
                                    }}
                                    onChange={ModulesAction.mapListToPage}
                                    showSizeChanger={true}
                                    pageSizeOptions={['10', '20', '30', '50', '100']}
                                />
                            </div> :
                            ''
                    }
                    <Modal
                        title="禁用用户"
                        visible={this.modulesState.disabledModal}
                        onOk={this.disabledUserSure}
                        onCancel={this.disabledModalCancel}
                        className='kts-app-ant-modal'
                    >
                        <p style={{ display: 'flex', alignItems: 'center' }}><Icon type="zhuyi" style={{ color: '#ffb301', fontSize: '24px', marginRight: '12px' }} />你确认要禁用用户{this.modulesState.disabledName}吗？</p>
                    </Modal>
                </div>
            </div>
        );
    }

    private userHander = props => {
        const record = props.record;
        if (record.isActivated) {
            return (
                <a
                    onClick={() => {
                        this.disabledModal(record.userId, record.nickName);
                    }}
                >禁用
                </a>
            );
        } else if (!record.isActivated && record.acceptStatus === 'ACCEPT_ING') {
            return (
                <a
                    onClick={() => {
                        this.invitationUser(record.userId);
                    }}
                >邀请
                </a>
            );
        } else {
            return (
                <a
                    onClick={() => {
                        this.setupUserDisOr(record.userId, false);
                    }}
                >启用
                </a>
            );
        }
    }

    private setupUserDisOr = (userId, bo) => {
        ModulesAction.setupUserDisOr({
            userId,
            status: bo
        });
    }

    private invitationUser = (userId) => {
        const domain = window.location.origin;
        ModulesAction.invitationUser({
            userId,
            domain
        });
    }

    private reviewDetali = record => {
        this.modulesState.gUserId = record.gUserId;
        this.modulesState.userId = record.userId;
        this.setModulesState();
        ModulesAction.updateRefreshEdit(true);
        ModulesAction.updateIsInnerUserControl(true);
        ModulesAction.updateSecurityMgr({ userId: record.userId });
        ModulesAction.getJobList(record.userId);
        ModulesAction.getUserInfo({ userId: record.userId }).then(res => {
            // MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
            //     Components: <Edit type={1} userId={userId}/>,
            //     title: '查看用户'
            // });
            MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
                Components: <View type={1} userId={record.userId} />,
                title: '查看用户'
            });
        });
    }

    private handleInfiniteOnLoad = () => {
        ModulesAction.updataUserListPageMeta(20);
        const options = Object.assign({}, this.modulesState.filterOptions, this.modulesState.userListPageMeta);
        ModulesAction.getUserQuery(options);
    }

    private disabledModal = (userId, name) => {
        ModulesAction.updateDisableModal(true);
        ModulesAction.updateDisabledUser(userId, name);
    }

    private disabledModalCancel = () => {
        ModulesAction.updateDisableModal(false);
    }

    private disabledUserSure = () => {
        ModulesAction.setupUserDisOr({
            userId: this.modulesState.disabledUserId,
            status: true
        }).then((res: any) => {
            if (!res) {
                this.disabledModalCancel();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/UserManage/UI.Table.tsx